import checkEquality from '@/lib/helpers/check-equality';

const defineProperty = (
  instance,
  propertyName,
) => {
  const getter = () => instance.$modelStore[propertyName];
  const setter = (newValue) => {
    if (!checkEquality(instance.$modelData[propertyName], newValue)) {
      instance.$modelData[propertyName] = newValue;
      instance.$updateModelToStore(propertyName);
    }
  };

  Object.defineProperty(instance, propertyName, {
    get: () => getter(),
    set: newValue => setter(newValue),
  });
};

export default defineProperty;
